import React from 'react';
import DSButton from '@elliemae/ds-basic/Button';
import { ShuttleListPanel as ShuttleListPanel$1 } from '../classedComponents.js';
import '@elliemae/ds-classnames';
import './ShuttleBreadcrumb.js';
import 'react-spring/web.cjs';
import '@elliemae/ds-basic/Breadcrumb';
import '../animation/animationConfig.js';
import './OverflowList.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '../AnimationState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';

function ShuttleListPanel(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ShuttleListPanel$1, {
    classProps: {
      open: open
    }
  }, /*#__PURE__*/React.createElement(DSButton, {
    buttonType: "text",
    icon: children,
    onClick: onClick,
    "data-testid": "list-panel-btn"
  }));
}

export default ShuttleListPanel;
//# sourceMappingURL=ShuttleListPanel.js.map
